import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=ab675b94&scoped=true&"
import script from "./QuotationList.vue?vue&type=script&lang=js&"
export * from "./QuotationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab675b94",
  null
  
)

export default component.exports